<div class="loading-overlay">
	<div class="loading-content">
		<div class="spinner"></div>
		<div class="message">{{ mensajeActual }}</div>
	</div>
</div>
